// components/VesselDetails.jsx

import ModulesHeader from "@components/common/ModulesHeader";
import ContactIcon from "@components/icons/ContactIcon";
import { useIsMobile, useIsTablet } from "@components/mediaQuery/useIsMobile";
import { useFeatureIsOn, useFeatureValue } from "@growthbook/growthbook-react";
import { getActivationTabs, getConfigurationTabs, getMonitoringTabs } from "@utils/tabsConfig.jsx";
import { IS_ADMIN_ROLE, IS_DISTRIBUTOR_ROLE } from "@utils/user_roles";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/common/Button";
import ButtonGroup from "../../../components/common/ButtonGroup";
import Tabs from "../../../components/common/Tabs";
import ModalContactSupport from "../../../components/Modals/ModalContactSupport";
import { FLAGS } from "../../../config/growthbook/flags.js";
import { fetchVesselById, fetchVesselUsers } from "../../../services/vesselService";
import { setSelectedModule } from "../../../store/modules/sidebarSlice";
import { setLoadingVesselKits, setVesselUsers } from "../../../store/modules/vesselsSlice";

const VesselDetails = () => {
	const { id, idkit } = useParams();
	const logRef = useRef(false);

	const [selectedContent, setSelectedContent] = useState("monitoring");
	const [isModalOpenSupport, setIsModalOpenSupport] = useState(false);
	const token = useSelector((state) => state.auth.user.token);
	const starlinks = useSelector((state) => state.modules.vessels.vesselDetails?.starlinks);
	const intelsats = useSelector((state) => state.modules.vessels.vesselDetails?.intelsats);
	const cellular = useSelector((state) => state.modules.vessels.vesselDetails?.smartboxes);

	const cybersecurity = useSelector(
		(state) => state.modules.vessels.vesselDetails?.cybersecurity_id,
	);

	const fortigate = useSelector((state) => state.modules.vessels.vesselDetails?.fortigate);

	const yahsatServices = useSelector((state) => state.modules.vessels.vesselDetails?.yahclick);
	const selectedVessel = useSelector((state) => state.modules.vessels.selectedVessel);
	const vesselId = useSelector((state) => state.modules.vessels.vesselDetails?.id);
	const modules = useSelector((state) => state.modules.vessels.vesselDetails?.modules);
	const vesselName = useSelector((state) => state.modules.vessels.vesselDetails?.site_name);
	const accessUsersVisible = useFeatureIsOn(FLAGS.vessels.overview.accessUsersVisible);

	const userroleId = useSelector((state) => state.auth.user.role?.id);
	const isAllowed = accessUsersVisible && [IS_ADMIN_ROLE, IS_DISTRIBUTOR_ROLE].includes(userroleId);

	const showPeplink = modules?.some((module) => module.name === "Peplink");
	const showStarlink = modules?.some((module) => module.name === "Starlink");
	const showIntelsat = modules?.some((module) => module.name === "Intelsat");
	const showCyberSecurity = modules?.some((module) => module.name === "CyberSecurity");
	const showFortigate = modules?.some((module) => module.name === "Fortigate");

	const showVouchers = modules?.some((module) => module.name.toLowerCase() === "voucher services");
	const showYahsatServices = modules?.some((module) => module.name === "Yahsat Services");
	const showVoucherToken = useSelector(
		(state) => state.modules.vessels?.vesselDetails?.captive_portals?.length > 0 || false,
	);

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const displaystarlink = Array.isArray(starlinks) && starlinks.length > 0;
	const displaycellular = Array.isArray(cellular) && cellular.length > 0;
	const displayintelsat = Array.isArray(intelsats) && intelsats.length > 0;

	const displaycybersecurity =
		Array.isArray(cybersecurity) && (cybersecurity !== undefined || cybersecurity !== null);

	const displayfortigate = Array.isArray(fortigate) && fortigate.length > 0;
	const displayVouchers = modules?.some(
		(module) => module.name.toLowerCase() === "voucher services",
	);

	const displayYahsatServices = Array.isArray(yahsatServices) && yahsatServices.length > 0;

	const displayInmarsatDp = vesselId === 9488;

	console.log("displayInmarsatDp", displayInmarsatDp);

	const [selectedKit, setSelectedKit] = useState(false);
	const business_units = useSelector((state) => state.auth.user?.business_units);

	useEffect(() => {
		setSelectedKit(Boolean(starlinks?.length));
	}, [starlinks]);
	useEffect(() => {
		if (!logRef.current) {
			logRef.current = true;
			if (id && token && (!selectedVessel || selectedVessel?.id !== id || vesselId !== vesselId)) {
				const url = `/vessel/${id}`;
				dispatch(
					setSelectedModule({
						name: "vessels_site",
						display_name: "Vessels/Site",
					}),
				);

				fetchVesselById({
					id,
					name: selectedVessel?.name,
					token,
					dispatch,
					navigate,
				}).catch((e) => {
					navigate("/vessels_site", { replace: true });
				});
			}
		}
	}, [id, token]);

	useEffect(() => {
		if (!isAllowed) return;

		const controller = new AbortController();

		const loadUsers = async () => {
			const data = await fetchVesselUsers(
				token,
				id,
				dispatch,
				navigate,
				1,
				10,
				null,
				1,
				controller.signal,
			);
			dispatch(setVesselUsers(data));
		};

		loadUsers();

		return () => {
			controller.abort();
		};
	}, [id, token, isAllowed]);

	const handleConfigurationClick = () => {
		setSelectedContent("configuration");
	};

	const handleMonitoringClick = () => {
		setSelectedContent("monitoring");
	};
	const handleActivationClick = () => {
		dispatch(setLoadingVesselKits(true));
		setSelectedContent("activation");
	};

	const openModalSupport = () => setIsModalOpenSupport(true);
	const closeModalSupport = () => setIsModalOpenSupport(false);

	const tabs = getMonitoringTabs(
		displaystarlink,
		displaycellular,
		displaycybersecurity,
		vesselId,
		displayintelsat,
		showPeplink,
		showStarlink,
		showIntelsat,
		showCyberSecurity,
		displayfortigate,
		showFortigate,
		displayVouchers,
		displayYahsatServices,
		showVouchers,
		showYahsatServices,
		showVoucherToken,
		displayInmarsatDp,
	);
	const tabsActivation = getActivationTabs(
		displaystarlink,
		displaycellular,
		showStarlink,
		showPeplink,
		displayfortigate,
		showFortigate,
	);
	const tabsConfiguration = getConfigurationTabs();
	const isTablet = useIsTablet();
	const isMobile = useIsMobile();

	const visibleActivationTabs = tabsActivation.filter((tab) => tab.display);
	const defaultActivationTab = visibleActivationTabs[0]?.name;

	const titlesConfig = useFeatureValue(FLAGS.shared.vessels.titlesConfig, {
		vessels_site: "Vessels/Sites",
		vessel: "Vessel/Site",
	});

	return (
		<div className="px-0 pt-20 pb-4 sm:px-2 md:px-4 lg:px-4 xl:px-4 2xl:px-4">
			{isTablet && (
				<ModulesHeader
					vesselsite={vesselName}
					subModuleTitle={titlesConfig.vessel}
					isPresent={true}
					isVessel={true}
				/>
			)}
			{selectedKit && (
				<div className={`mt-4 flex ${isMobile ? "items-center justify-center" : "justify-start"}`}>
					<Button
						text="CONTACT SUPPORT"
						className="rounded-lg bg-blue-gray py-2 text-[8px] text-white hover:bg-button-hover sm:text-[8px] md:text-[10px] lg:text-[12px] xl:text-[14px]"
						color="white"
						onClick={openModalSupport}
						icon={ContactIcon}
					/>

					<ModalContactSupport
						isOpen={isModalOpenSupport}
						closeModal={closeModalSupport}
						displayStarlinkOptions={displaystarlink}
						liststarlink={starlinks}
						dispatch={dispatch}
						navigate={navigate}
						token={token}
					/>
				</div>
			)}
			<div className="mt-6 flex justify-center">
				<ButtonGroup
					onConfigurationClick={handleConfigurationClick}
					onMonitoringClick={handleMonitoringClick}
					onActivationClick={handleActivationClick}
					selectedContent={selectedContent}
					canDisplayActivationProv={
						(showPeplink && displaycellular) ||
						(showStarlink && displaystarlink) ||
						(showFortigate && displayfortigate)
					}
				/>
			</div>
			{selectedContent === "monitoring" ? (
				<div className="">
					<Tabs defaultTab="overview" tabs={tabs} />
				</div>
			) : selectedContent === "activation" ? (
				<div className="">
					<Tabs defaultTab={defaultActivationTab} tabs={tabsActivation} />
				</div>
			) : (
				selectedContent === "configuration" && (
					<div className="">
						<Tabs defaultTab="generalconfig" tabs={tabsConfiguration} />
					</div>
				)
			)}
		</div>
	);
};

export default VesselDetails;
